import React, { Component } from "react";
import $ from 'jquery';
import initFitnessJS from "../../streaming/FitnessController";
import Util from "../../streaming/Util";
import Language from '../../services/contentData';

class FooterScriptParticipant extends Component {
 
  componentDidMount(){
    
    var loadScript = function (src) {
      var tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(tag);
    }

    loadScript('./js/swiper.min.js');
    loadScript('./js/swiper-modifier.js');
	
	initFitnessJS();
  }

  getScore = () => {
      $(".score").toggleClass('opacity-zero');
      $('#score').text(90);
  }

  hideScore = () => {
      $(".score").addClass('opacity-zero');
      $('#score').text(90);
  }

  setScore = () => {
    $(".score").addClass('opacity-zero');

    let scriptName = $('.carousel-item.active h3').text();
    let score      = parseInt($('#score').text());
    window.setWineScore(scriptName, score);
    $('#score').text(90);
    $('#wine-score').text(score);
  }

  incrementScore = () => {
      let score = parseInt($('#score').text());
      if (score < 100) {
          $('#score').text(score + 1);
      }
  }

  decrementScore = () => {
      let score = parseInt($('#score').text());
      if (score > 0) {
          $('#score').text(score - 1);
      }
  }

  handleButtonClick1 = ()=> {

    let loadScript = function (src) {
      var tag = document.createElement('script');
      tag.async = false;
      tag.src = src;
      
      var body = document.getElementsByTagName('body')[0];
      body.appendChild(tag);
    }

    loadScript('./js/swiper.min.js');
    loadScript('./js/swiper-modifier.js');
	
	if ( window['loadSwiperSlide1'] )
		{
			 window.loadSwiperSlide1();
		}
   
    window.mySwiper.slideTo(0, 1000, true);
    this.forceUpdate();  
  }

  showActivityList = () => {
      $('.activity_list_popup').removeClass('d-none');
  }

render() {

  let localstoragedata = JSON.parse(localStorage.getItem('userData'));
  let sessionScript = null;

  if (localstoragedata !== null) 
  {
      sessionScript = localstoragedata.sessionData.scriptDetail;
  }

  return (
    
       <div className="w-50">
       { this.props.groupId == 1 ? (
       
          <div className="swiper-fitness-container float-left position-relative">           
            <div className="d-flex b-10 w-100 justify-content-between arrow-after align-items-center footer-fitness-script">
              <div className="swiper-container">
                <button  id="stop1-script"  onClick={this.handleButtonClick1} className="mr-2 stop-btn" hidden="hidden">fitnessStop</button>
                <div className="main-heading activity-counter counter_button_hold" onClick={this.showActivityList.bind(this)}><span><span id="fitness-counter">0</span>/<span id="scriptMainLength">{Util.getScriptLength(localstoragedata)}</span></span></div>
                <div className="swiper-wrapper align-items-center fitness-guest">
                  <div className="swiper-guest swiper-slide position-relative start d-none">              
                    <span className="position-relative" id="swip_slide">
                      <a href="javascript:void(0)">Start</a>
                    </span>
                    <div className="prevent-click"></div>
                  </div>
              
                    {(Array.isArray(sessionScript)) &&
                        sessionScript.map((opt, i) =>                                                 
                          <div className="swiper-slide newcounter" data-index={i+1} key={i} id={"swiper-slide"+i} data-index-counter={i+1}>
                              <h4 className="new_script_name_part">{opt.name}</h4>                              
                              <div id="countdown" className="count-timer data-slide" data-index={i+1} data-index-counter={i}>
                              {opt.attribute.map(function(attrb, index){
                                if(attrb.attrLabel == 'counter'){
                                  return <div className="countdown-number" data-number={attrb.attrValue} key={index}>{attrb.attrValue}</div>;
                                } else if(attrb.attrLabel.toLowerCase() == 'video' && attrb.attrValue != '' && attrb.attrValue != 'NA') {
                                    return <div className ='injectVideo' value ={encodeURI(attrb.attrValue)}></div>;
                                } else if(attrb.attrLabel.toLowerCase() == 'videorepeat' && attrb.attrLabel != '') {
                                    return <div className ='injectVideoReap' repeatvideo={attrb.attrValue}></div>;
                                } else if(attrb.attrLabel.toLowerCase() == 'repsseconds' && attrb.attrValue > 1) {
                                    return <div className ='interval' intervaltime={attrb.attrValue}></div>;
                                } else if(attrb.attrLabel == 'Activity Type' && (attrb.attrValue.toLowerCase() == 'pause' || attrb.attrValue.toLowerCase() == 'pause virtual')){
                                  //window['hideScript'](i+1)
								                } else if(attrb.attrLabel == 'Activity Type'){
                                    return <div className ='activityType d-none'>{attrb.attrValue.toLowerCase()}</div>;
                                }
                              })}

                              <div id="reps-counter" className="d-none">0</div>

                              <svg>
                                <circle r="39" cx="43" cy="43"></circle>
                              </svg>
          
                            </div>
                          </div>
                    )}

                    <div className="swiper-guest swiper-slide end">              
                        <span>
                          <a href="javascript:void(0">End</a>
                        </span>
                    </div>
                </div>
              </div>
            </div>
          </div>
      ) : (
        this.props.groupId == 2 ? (
          <div className="participent-emoji h_auto mb-2">
            <div><ul className="bottom-links flex-wrap list-group list-group-horizontal mx-auto d-md-flex justify-content-center py-xs-1"></ul></div>
            <div className="position-relative">
              <div className="d-flex score radius-10 opacity-zero">
                <div className="d-flex white_border radius-8 w-110 text-white">
                  <div className="flex-fill text-center p-2 white_border_right cursor-pointer minus" onClick={this.decrementScore.bind(this)}>
                    <i className="fa fa-minus"></i>
                  </div>
                  <div className="flex-fill text-center p-2 white_border_right">
                    <p className="mb-0" id="score">90</p>
                  </div>
                  <div className="flex-fill text-center p-2 cursor-pointer plus" onClick={this.incrementScore.bind(this)}>
                    <i className="fa fa-plus"></i>
                  </div>
                </div>
                <div className="ml-3">
                  <a href="javascript:void(0)" className="save-btn btn btn-primary radius-10 mx-auto mt-1" onClick={this.setScore.bind(this)}>OK</a>
                </div>
              </div>
              <div className="score-btn" id="score_btn">
                <a href="javascript:void(0)" className="text-white position-relative" onClick={this.getScore.bind(this)}>SCORE<span className="badge score_count" id="wine-score"></span></a>
              </div>
            </div>
          </div>
        ) : ( <div> </div> )
      )
    }
       </div>
    );
  }
}

export default FooterScriptParticipant;